export enum UserSelectionDataHooks {
  USER_SELECTION_COMPONENT = 'user_selection',
  USER_SELECTION_BUTTON = 'user_selection_button',
}
